import {
  BaseQueryApi,
  BaseQueryFn,
  FetchArgs,
} from '@reduxjs/toolkit/query/react'
import {
  authApi,
  RenewTokensResponse,
  FireFighterAuthorizeResponse,
} from '../../api/auth/AuthApi'
import {
  setAtlasData,
  setAccessToken,
  setRefreshToken,
} from '../../redux/reducers/AtlasSandReducer'
import { UI_CONSTANTS } from '../constants/UIConstants'
import { FF_SESSION_KEY } from '../constants/apiConstants'
import { RootState } from '../../store/Store'

export const handleFireFighterReauth = async (
  api: BaseQueryApi,
  args: string | FetchArgs,
  extraOptions: NonNullable<unknown>,
  baseQuery: BaseQueryFn<string | FetchArgs>,
  currentResult: Awaited<ReturnType<BaseQueryFn<string | FetchArgs>>>,
) => {
  const refreshToken = (api.getState() as RootState).atlas.refreshToken
  const renewResult: { data?: RenewTokensResponse } = await api.dispatch(
    authApi.endpoints.renewTokens.initiate(refreshToken),
  )
  if (renewResult?.data?.requestStatus) {
    const newAccessToken = renewResult.data.data.accessToken
    const newRefreshToken = renewResult.data.data.refreshToken
    const authResponse: { data?: FireFighterAuthorizeResponse } =
      await api.dispatch(
        authApi.endpoints.getFireFighterAuthorize.initiate(newAccessToken),
      )
    if (authResponse?.data?.requestStatus) {
      localStorage.setItem(
        FF_SESSION_KEY,
        JSON.stringify({
          accessToken: newAccessToken,
          refreshToken: newRefreshToken,
        }),
      )
      api.dispatch(setAccessToken(newAccessToken))
      api.dispatch(setRefreshToken(newRefreshToken))
      await api.dispatch(
        setAtlasData({
          method: UI_CONSTANTS.AUTHORIZED_USER,
          data: authResponse.data.data,
        }),
      )
      return await baseQuery(args, api, extraOptions)
    } else {
      api.dispatch(setAccessToken(''))
      return currentResult
    }
  } else {
    api.dispatch(setAccessToken(''))
    return currentResult
  }
}
